import { render } from "./AddTypeDialog.vue?vue&type=template&id=13df4ce9"
import script from "./AddTypeDialog.vue?vue&type=script&lang=js"
export * from "./AddTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__